// A changed gateway must not retain an offline route cached before setup.
export function clearPersistentMapCaches(storage: Pick<Storage, "length" | "key" | "removeItem">) {
  const prefixes = ["geely-waiting-route-v2:", "geely-amap-driving-route-v3:", "geely-amap-lookup-v1:"];
  for (let index = storage.length - 1; index >= 0; index--) {
    const key = storage.key(index);
    if (key && prefixes.some(prefix => key.startsWith(prefix))) storage.removeItem(key);
  }
}
